import { StatusAction } from "./reviewStatusReducer";
import { UserReviewResult } from "./LeaveAReview";

const fetchUserReviewStatus = async (
  itemNumber: string,
  userRegistered: boolean | undefined,
  statusFetchComplete: boolean,
  statusDispatch: React.Dispatch<StatusAction>
) => {
  if (userRegistered) {
    await fetch(`/api/getuserreviewstatus?item_number=${itemNumber}`)
      .then((response) =>
        response.ok ? response.json<UserReviewResult>() : null
      )
      .then((result) => {
        statusDispatch({ type: "FETCH_STATUS", payload: result });
      })
      .catch(() => {
        statusDispatch({ type: "FETCH_ERROR" });
      });
  } else if (statusFetchComplete) {
    statusDispatch({ type: "RESET_STATUS" });
  }
};

export default fetchUserReviewStatus;
